var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93199 10.495C8.80199 10.495 8.68199 10.465 8.57199 10.405L4.37199 8.065C4.19199 7.965 4.06199 7.795 4.01199 7.595C3.96199 7.395 3.99199 7.185 4.10199 7.005L8.29199 0.344999C8.43199 0.124999 8.66199 -0.00500107 8.92199 -0.00500107C9.17199 -0.00500107 9.41199 0.124999 9.55199 0.334999L13.892 6.995C14.002 7.175 14.042 7.385 13.992 7.585C13.942 7.785 13.802 7.965 13.622 8.055L9.28199 10.395C9.17199 10.455 9.05199 10.485 8.92199 10.485L8.93199 10.495ZM5.79199 7.135L8.94199 8.885L12.202 7.125L8.94199 2.135L5.79199 7.135Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00199 17.995C8.74199 17.995 8.49199 17.855 8.36199 17.625L4.09199 10.475C3.92199 10.185 3.96199 9.825 4.18199 9.585C4.41199 9.345 4.76199 9.275 5.06199 9.425L9.01199 11.365L12.952 9.565C13.252 9.425 13.602 9.505 13.822 9.745C14.042 9.995 14.072 10.355 13.902 10.635L9.63199 17.645C9.49199 17.865 9.25199 18.005 8.99199 18.005L9.00199 17.995ZM6.67199 11.875L9.00199 15.785L11.352 11.925L9.31199 12.855C9.11199 12.945 8.87199 12.945 8.67199 12.855L6.67199 11.875Z",
    fill: "currentColor",
    className: "accent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.2ea3856593c15b007aa87277780e1fe3.svg";
export { ForwardRef as ReactComponent };